const Success: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      fill="none"
      height="19.794"
      viewBox="0 0 20 19.794"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="m17.611 9.897 0.513 -1.584c0.384 -1.185 -0.15 -2.474 -1.259 -3.041L15.382 4.515l-0.757 -1.482c-0.567 -1.109 -1.856 -1.644 -3.041 -1.259L10 2.286 8.416 1.773c-1.185 -0.384 -2.474 0.15 -3.041 1.259l-0.758 1.482 -1.482 0.758c-1.109 0.567 -1.643 1.856 -1.259 3.041L2.389 9.897 1.876 11.48c-0.384 1.185 0.15 2.474 1.259 3.041l1.482 0.757 0.757 1.482c0.567 1.109 1.856 1.644 3.041 1.259l1.584 -0.512 1.584 0.513c1.185 0.384 2.474 -0.15 3.041 -1.259l0.757 -1.482 1.482 -0.757c1.109 -0.567 1.644 -1.856 1.259 -3.041zm-9.019 3.057L6.701 11.063a0.825 0.825 0 0 1 0 -1.166 0.825 0.825 0 0 1 1.166 0l1.308 1.308L12.957 7.423a0.825 0.825 0 0 1 1.166 0 0.825 0.825 0 0 1 0 1.166L9.758 12.954a0.825 0.825 0 0 1 -1.166 0"
      />
    </svg>
  );
};

export default Success;
